import { useMemo } from 'react'
import { useMeetingMode } from './useMeetingMode'
import { getMeetingSettingsForMode } from '@shared/utils/meetings'

export const useMeetingSettings = () => {
  const { meetingMode } = useMeetingMode()

  const allowMeetingNotifications = useMemo(() => {
    const settings = getMeetingSettingsForMode(meetingMode)
    return settings.meetingNotifications
  }, [meetingMode])

  const detectMeetings = useMemo(() => {
    const settings = getMeetingSettingsForMode(meetingMode)
    return settings.meetingDetection
  }, [meetingMode])

  return {
    detectMeetings,
    allowMeetingNotifications,
  }
}
